import styled from "styled-components";

const Style = styled.div`
  margin: var(--size-lg);
  flex: 1;
  position: relative;
  overflow: hidden;
  border-radius: 16px;

  .map-c {
    height: 100%;
    width: 100%;

    .map-marker {
      background: #3D8EDB;
      border: 2px solid white;
      border-radius: 100% 100% 100% 0px;
    }
  }

  .leaflet-popup-content-wrapper {
    .leaflet-popup-content {
      margin: 0px !important;
      width: unset !important;
      padding: 6px 24px 6px 14px;
      
      .popup-header {
        display: flex;

        h2 {
          white-space: nowrap;
          margin-bottom: 0px;
          font-size: 14px;
        }
      }
    } 
  }

  .map-sider {
    top: 0;
    right: 0;
    width: 280px;
    height: 100%;
    z-index: 1000;
    background: white;
    display: flex;
    flex-direction: column;
    position: absolute;
    border-radius: 0px 16px 16px 0px;
    border: 1px solid var(--base-gray-40);

    .sider-header {
      display: flex;
      padding: 32px 24px 24px 24px;
      justify-content: space-between;
      border-bottom: 1px solid var(--base-gray-40);

      .close-icon {
        top: 6px;
        right: 6px;
        width: 18px;
        height: 18px;
        cursor: pointer;
        position: absolute;
        background: #F9FAFB;
        border-radius: 100%;
      }

      h1 {
        font-size: 18px;
        font-weight: 600;
      }
    }

    .sider-body {
      flex: 1;
      padding: 24px;
      overflow-y: auto;

      .sider-body-row {
        gap: 24px;
        display: flex;
        padding-bottom: 12px;
        justify-content: space-between;

        label {
          margin-bottom: 0px;
        }

        span {
          overflow: hidden;
          margin-bottom: 0px;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        &.bordered {
          margin-bottom: 12px;
          border-bottom: 1px solid var(--base-gray-30);
        }
      }

      .daf-table {
        padding: 0px;
        margin-top: 12px;

        table {
          width: unset !important;
        }
      }
    }
  }
`;

export default Style;
